/**
 * The published copy as a draft would hold it, keyed by `draftId`: the server keys the Rulebook by its own id, so the
 * draft's id is put in its place and never counts as a change. The submission in review wins over the live row.
 */
export default function toPublishedRulebookSnapshot({ record, draftId, }) {
    if (record.pending) {
        return { definition: { ...record.pending.definition, id: draftId }, meta: record.pending.meta };
    }
    const live = record.live;
    if (!live) {
        return null;
    }
    const definition = {
        id: draftId,
        name: live.name,
        ...(live.description !== undefined ? { description: live.description } : {}),
        meters: live.meters,
        combined_rules: live.combined_rules,
    };
    const meta = {
        ...(live.cover_url !== undefined ? { cover_url: live.cover_url } : {}),
        tags: live.tags,
        visibility: live.visibility,
        definition_visible: live.definition_visible,
    };
    return { definition, meta };
}
